import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FileService } from '../services/file.service';
import { TipologiaMenu, TipologiaSubMenu, CustomValue, TipologiaDto, Documento, AttachmentDto, MetadatoTipologiaDto } from '../models/data.model';
import { DataService } from '../services/data.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../services/common.service';
import { MimetypeService } from '../services/mimetype.service';
import { TranslateService } from '@ngx-translate/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  NgForm
} from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';




@Component({
  selector: 'app-international-activities',
  templateUrl: './international-activities.component.html',
  styleUrls: ['./international-activities.component.css']
})


export class InternationalActivitiesComponent implements OnInit {

  @ViewChild('Prod') ProdElement;
  @ViewChild('Disc') DiscElement;
  @ViewChild('All') AllElement;

  @ViewChild('DynamicForm') DynamicFormElement;
  @ViewChild('DynamicInput') DynamicInputElement;

  srch: Documento = null;
  public internationalActivitiesFilter: any = '';

  Rank = [1,2,3,4,5];
  starList: boolean[] = [true, true, true, true, true];
  rating: number;
  setStar(data: any) {
    this.rating = data + 1;
    for (var i = 0; i <= 4; i++) {
      if (i <= data) {
        this.starList[i] = false;
      }
      else {
        this.starList[i] = true;
      }
    }
  }

  constructor(private tipologiService: FileService,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private distinctValueService: CommonService<CustomValue>,
    private tipologiaService: CommonService<TipologiaDto[]>,
    private documentService: CommonService<Documento>,
    private fileServer: CommonService<AttachmentDto>,
    public translate: TranslateService,
    private mimeTypeService: MimetypeService,
    private modalService: NgbModal ) { }
  tipologies: TipologiaMenu[] = [];
  isExpanded = false;
  lineaProdotto: string;
  //selecteditem: TipologiaSubMenu = null;

  Feedback: string;
  PasswordAllegato: string = ''; 
  modelList: string[] = [];
  clinicalApplicationList: string[] = [];
  AppoggioProbe: string[] = [];
  probeList: string[] = [];
  classificationList: string[] = [];
  applicationList: string[] = [];
  isShowResultButton: boolean = false;
  idTipologia: number = 2;
  documents: Documento[] = [];
  fullLinea: string;
  area: string;
  typeToRefresh: string;
  probes: string[] = [];
  clinicalapplications: string[] = [];
  models: string[] = [];
  applications: string[] = [];
  modelsFiltered: string[] = [];
  applicationsFiltered: string[] = [];
  modelSelected: string = 'All models';
  applicationSelected: string = 'All applications';
  valueSearchSelected: string;
  Ritorno = '';
  RichiediPassword = false;

  selected: any = {
    item: null,
    model: null,
    classification: null,
    clinicalapplication: null,
    application: null,
    probe:null,
    textToSearch: null,
  }
  selectedFromInput: string;
  ngOnInit() {

    //Temporary if they want exact refer to fullLinea
    this.fullLinea = this.activatedRoute.snapshot.paramMap.get('linea');
    let fullLineaSplited = this.fullLinea.split('_');
    this.lineaProdotto = fullLineaSplited[0];
    let sectionArea = fullLineaSplited[1];
    //this.area = sectionArea === 'SERV' ? 'SERVICE' : 'MARKETING_SALES';
    this.area = sectionArea === 'SERV' ? 'SERVICE' : sectionArea === 'SMKT' ? 'MARKETING_SALES' : "CERT";
    // console.log('lineaProdotto : ', this.lineaProdotto);
  
    this.dataService.ComponentInput = 'INTERNATIONALACTIVITIES.TITLE';
    this.getTipologia().then((Tipologies) => {
      let dbTipologies = Tipologies as TipologiaDto[];
      this.getTipologieMenu(dbTipologies);
    });
  }




  placeholder: string = 'Password';
  DocAttesa: Documento;
  AllegatoDtoAttesa: AttachmentDto;
  //se false visualizza, se true scarica 
  ArcaOperazione: boolean;

  ApriRichiestaPassword(doc: Documento, Allegato: AttachmentDto, ArcaOperazione: boolean) {

    let isPreset = false;
    this.placeholder = 'Password';
    doc.metadatiDtoList.forEach(item => {

       let itemN = item.key.replace(/_/g, " ");
       item.key = itemN;

       if (item.key === "Clinical application") {
          isPreset = true; 
        }
    });

    if (isPreset) {
      this.RichiediPassword = true;
      this.ArcaOperazione = ArcaOperazione;
      this.DocAttesa = doc;
      this.AllegatoDtoAttesa = Allegato;

    } else {

      this.PasswordAllegato = '' 
      this.RichiediPassword = false 
      this.getArcadocAttach(doc.allegatoPrimarioDto, doc.idDocumento, ArcaOperazione);
      
    }
  }

  ConfermaPassword(cancel: boolean = false) {
    let PassArcaDoc = ''; 

    if (this.DocAttesa != undefined) {
      this.DocAttesa.metadatiDtoList.forEach(item => {
        let itemN = item.key.replace(/_/g, " ");
        item.key = itemN;
        //if (item.key === "Password Attachment") {
        if (item.key === "AttachmentCode") {
          PassArcaDoc = item.value;
        }
      });
      if (cancel) {
        this.RichiediPassword = false;

      } else if (this.PasswordAllegato == PassArcaDoc && !cancel) {

        this.getArcadocAttach(this.AllegatoDtoAttesa, this.DocAttesa.idDocumento, this.ArcaOperazione);

        this.memorizzaConsultazioneAllegato(this.DocAttesa.idDocumento, this.AllegatoDtoAttesa.idAllegato)
      } else {
        this.placeholder = 'Invalid entry';

      }
      this.PasswordAllegato = '';
    }
  }

  getTipologieMenu = (dbTipologies: TipologiaDto[]) => {
    this.tipologies = [];
    this.tipologiService.getAllTipologies().subscribe(data => //Call our public function
    {
      Object.keys(data).forEach(key => {

        if (key === this.area) {
          let item = data[key];
          let menu: TipologiaMenu = new TipologiaMenu();
          menu.title = 'INTERNATIONALACTIVITIES.' + key;
          menu.childMenu = [];
          Object.keys(data[key]).forEach(subKey => {
            let subItem = item[subKey];
            let subMenu: TipologiaSubMenu = new TipologiaSubMenu();
            let nome = this.lineaProdotto + '_' + subItem["Area"];
            try {
              
              subMenu.idTipologia = dbTipologies.find(x => x.nomeTipologia === nome).idTipologia;
              subMenu.title = 'INTERNATIONALACTIVITIES.' + subKey;
              subMenu.isIncludeClassification = subItem["Classification"];
              subMenu.isIncludeModel = subItem["Model"];
              subMenu.isIncludeClinicalApplication = subItem["ClinicalApplication"];
              subMenu.isIncludeCorrelatedProbeList = subItem["CorrelatedProbeList"];
              subMenu.isIncludedApplication = subItem["Application"];
              subMenu.area = subItem["Area"];
              menu.childMenu.push(subMenu);
            }
            catch (x) {
              console.log('Menu not found due to lack of permission');
            }
          })
          this.tipologies.push(menu);
        }
      });
    });
    //console.log('this is tipologie menu : ', this.tipologies);
  }

  public trackByFn(index, item) {
    if (!item) return null;
    return index;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  /* Evolutive Maggio Giugno Luglio 2021: Dropdown filtro model dinamica alla pressione di tasti */
  onSearchChangeModel(searchValue: string): void {
    
    if (searchValue != null && searchValue != undefined && searchValue.length >= 1) {
      this.modelsFiltered = this.models.filter(x => x != null && x != undefined && x != "" && x.toLowerCase().includes(searchValue.toLowerCase()));

       
    } else {
      this.modelsFiltered = [];
    }
  }
  onSearchChangeApplication(searchValue: string): void {

    if (searchValue != null && searchValue != undefined && searchValue.length >= 1) {
      this.applicationsFiltered = this.applications.filter(x => x != null && x != undefined && x != "" && x.toLowerCase().includes(searchValue.toLowerCase()));


    } else {
      this.applicationsFiltered = [];
    }
  }


  setModelToShowResult(model: string): void {
      this.selected.model = model;
  }
  setApplicationToShowResult(application: string): void {
    this.selected.application = application;
  }
  /* Evolutive Maggio Giugno Luglio 2021: Filtro campo Arcadoc In Produzione / Discontinued / All */
    onCheckBoxChange(CheckBoxValue: string): void {
    if (CheckBoxValue != null && CheckBoxValue != undefined && CheckBoxValue != "") {
      if (CheckBoxValue == 'prod') {
        this.AllElement.nativeElement.checked = false;
        this.DiscElement.nativeElement.checked = false;
      }
      if (CheckBoxValue == 'disc') {
        this.AllElement.nativeElement.checked = false;
        this.ProdElement.nativeElement.checked = false;
      }
      if (CheckBoxValue == 'all') {
        this.ProdElement.nativeElement.checked = false;
        this.DiscElement.nativeElement.checked = false;
      }

      this.fetchDistinctValues(this.selected.item.area, "Model", ",", this.selected.item.idTipologia, "ND", CheckBoxValue).then(
        result => {
          this.modelList = result as string[];
          this.modelList = this.modelList
            .map(s => s.trim())  // trim
            .filter((value, index, self) => self.indexOf(value) === index)  // unique
            .sort().reverse();  // sort
          let translateKey = "INTERNATIONALACTIVITIES.ALLMODELS";
          this.translate.get([translateKey])
            .subscribe(values => {
              this.modelList.unshift(values[translateKey]);
              this.selected.model = this.modelList[0];
              this.models = this.modelList;
            });
          if (CheckBoxValue == 'prod' || CheckBoxValue == 'disc') {
            this.modelList.shift();
          } 
        }, error => {
          console.error('error on get Models', error);
        });


    }
  }

  /* Evolutive Maggio Giugno Luglio 2021: Filtro ricerca fulltext */
  onTextSearchChange(searchValue: string): void {
    console.log(searchValue);
    if (searchValue != null && searchValue != undefined && searchValue != "") {
      this.selected.textToSearch = searchValue;
    } else {
      this.selected.textToSearch = "";
    }
  }

  /* Evolutive Maggio Giugno Luglio 2021: Filtro dropdown classification: si refresha alla selezione del model */
  setSelectedModel(modelObject: string, typeToRefresh:string): void {
    this.modelSelected = modelObject;
    const modelType = "Model#"
    this.getVetrinaToRefreshType(modelType + modelObject, typeToRefresh);    
  }
  setSelectedApplication(applicationObject: string, typeToRefresh: string): void {
    this.applicationSelected = applicationObject;
    const applicationType = "Application#"

    this.getVetrinaToRefreshType(applicationType + applicationObject, typeToRefresh);
  }
  getVetrinaToRefreshType = (typeAndObject: string, typeToRefresh: string) => {
    this.isShowResultButton = false;
    this.selected.classification = null;
    this.documents = [];
    //call to fetch classification
    if (typeAndObject != null && typeAndObject != undefined && typeAndObject != "") {
      console.log("object " + typeAndObject)
      this.fetchDistinctValues(this.selected.item.area, typeToRefresh, ",", this.selected.item.idTipologia, typeAndObject, 'ND').then(
        result => {
          console.log()
        /* Evolutive International Activities Esaote maggio/giugno 2022: Nuova linea di prodotti Preset: *
        Costumizzazione per la visualizzazione dei Preset, che hanno i campi Clinical_application e Correlated Probe List invece che Classification */
          if (typeToRefresh == "Clinical_application") {
            this.AppoggioProbe = result as string[];
            this.CaricaProbeList("", false);
            //this.probeList = this.clinicalApplicationList.map(s => s.split(' ').slice(1, s.split(' ').length).join(' '));
            console.log(this.probeList);

            this.clinicalApplicationList = this.AppoggioProbe.map(s => s.split('_')[0]);
            this.clinicalApplicationList = this.clinicalApplicationList
              .map(s => s.trim())  // trim
              .filter((value, index, self) => self.indexOf(value) === index)  // unique
              .sort();  // sort
            let translateKey = "INTERNATIONALACTIVITIES.ALLCLINICALAPPLICATION";
            this.translate.get([translateKey])
              .subscribe(values => {
                this.clinicalApplicationList.unshift(values[translateKey]);
                this.selected.clinicalapplication = this.clinicalApplicationList[0];
                this.clinicalapplications = this.clinicalApplicationList;
              });
          } else if (typeToRefresh == "Classification") {

            console.log("EEENNTTRRAAA")
            this.classificationList = result as string[];
            console.log(this.classificationList)
            let translateKey = "INTERNATIONALACTIVITIES.ALLCLASSIFICATION";
            this.translate.get([translateKey])
              .subscribe(values => {
                this.classificationList.unshift(values[translateKey]);
                this.selected.classification = this.classificationList[0];
              });     
          } 
        }, error => {
          console.error('error on get' + typeToRefresh, error);
        });
    }
  }

  getVetrina = (item: TipologiaSubMenu) => {
    this.isShowResultButton = false;
    this.selected.item = item;
    this.selected.classification = null;
    this.selected.model = null;
    this.selected.application = null;
    this.documents = [];
    console.log("ok entra qui");
    if (item.isIncludedApplication) {
      console.log("ok entra qui 1");

      this.typeToRefresh = "Classification";
      //call to fetch classification
      this.fetchDistinctValues(item.area, "Application", ",", item.idTipologia, "ND", 'ND').then(
          result => {
          this.applicationList = result as string[];
          console.log(this.applicationList)
          this.applicationList = this.applicationList
                .map(s => s.trim())  // trim
                .filter((value, index, self) => self.indexOf(value) === index)  // unique
                .sort().reverse();  // sort
          console.log(this.applicationList)

            let translateKey = "INTERNATIONALACTIVITIES.ALLAPPLICATION";
            this.translate.get([translateKey])
              .subscribe(values => {
                this.applicationList.unshift(values[translateKey]);
                this.selected.application = this.applicationList[0];
                this.applications = this.applicationList;
              });
          }, error => {
            console.error('error on get Applications', error);
          });
    }
    if (item.isIncludeModel) {
      console.log("ok entra qui 1");

      //Call to fetch models
      this.fetchDistinctValues(item.area, "Model", ",", item.idTipologia, "ND", 'all').then(
        result => {
          this.modelList = result as string[];
          if (item.isIncludeCorrelatedProbeList) {
            this.modelList = this.modelList
              .map(s => s.trim())  // trim
              .filter((value, index, self) => self.indexOf(value) === index)  // unique
            //.sort();  Evolutive Preset: Solo per il preset i modelli non vanno ordinati alfabeticamente
          } else {
            this.modelList = this.modelList
              .map(s => s.trim())  // trim
              .filter((value, index, self) => self.indexOf(value) === index)  // unique
              .sort().reverse();  // sort
          }
          let translateKey = "INTERNATIONALACTIVITIES.ALLMODELS";
          this.translate.get([translateKey])
            .subscribe(values => {
              this.modelList.unshift(values[translateKey]);
              this.selected.model = this.modelList[0];
              this.models = this.modelList;
            });
        }, error => {
          console.error('error on get Models', error);
        });
    }


    if (item.isIncludeClassification) {
      console.log("ok entra qui cl");

        this.typeToRefresh = "Classification";
      //call to fetch classification
      this.fetchDistinctValues(item.area, "Classification", ",", item.idTipologia, "ND", 'ND').then(
        result => {
          this.classificationList = result as string[];
         // console.log(this.classificationList);
          let translateKey = "INTERNATIONALACTIVITIES.ALLCLASSIFICATION";
          this.translate.get([translateKey])
            .subscribe(values => {
              this.classificationList.unshift(values[translateKey]);
              this.selected.classification = this.classificationList[0];
            });
        }, error => {
          console.error('error on get classification', error);
      });
      }
    
      /* Evolutive International Activities Esaote maggio/giugno 2022: Nuova linea di prodotti Preset: *
        Costumizzazione per la visualizzazione dei Preset, che hanno i campi Clinical_application e Correlated Probe List invece che Classification */
    if (item.isIncludeClinicalApplication || item.isIncludeCorrelatedProbeList) {
      console.log("ok entra qui clapp");

        this.typeToRefresh = "Clinical_application";
        //Call to fetch ClinicalApplications
        this.fetchDistinctValues(item.area, "Clinical_application", ",", item.idTipologia, "ND", 'all').then(
          result => {
            console.log(result);
            if (item.isIncludeCorrelatedProbeList) {
              this.AppoggioProbe = result as string[];
              this.CaricaProbeList("", false)
              this.clinicalApplicationList = this.AppoggioProbe.map(s => s.split('_')[0]);
            } else {
              this.clinicalApplicationList = result as string[];
            }
            this.clinicalApplicationList = this.clinicalApplicationList
              .map(s => s.trim())  // trim
              .filter((value, index, self) => self.indexOf(value) === index)  // unique
              .sort();  // sort
            let translateKey = "INTERNATIONALACTIVITIES.ALLCLINICALAPPLICATION";
            this.translate.get([translateKey])
              .subscribe(values => {
                this.clinicalApplicationList.unshift(values[translateKey]);
                this.selected.clinicalapplication = this.clinicalApplicationList [0];
                this.clinicalapplications = this.clinicalApplicationList ;
              });
          }, error => {
            console.error('error on get clinical applications', error);
          });
      }
   
  }
  CaricaProbeList(filtro: string, isNotPostBAck: boolean) {
    console.log("this.probeList.length " + this.probeList.length)
    if (!isNotPostBAck || this.probeList.length > 0) {
      console.log("entraProbe")
    this.probeList = this.AppoggioProbe.filter(f => f.startsWith(filtro))
      .map(s => s.split('_').slice(1, s.split('_').length).join(' '));
    this.probeList = this.probeList
              .map(s => s.trim())  // trim
              .filter((value, index, self) => self.indexOf(value) === index)  // unique
              .sort();  // sort
            let translateKey = "INTERNATIONALACTIVITIES.ALLPROBE";
            this.translate.get([translateKey])
              .subscribe(values => {
                this.probeList.unshift(values[translateKey]);
                this.selected.probe = this.probeList[0];
                this.probes = this.probeList ;
              });
    }
  }

  getTipologia = () => {
    return new Promise((resolve, reject) => {
      let url = 'api/rest/GetTipologia';
      let params = { params: { lineaprodotto: this.fullLinea, area: '' } };
      this.tipologiaService.getData(url, params, false).subscribe(result => {
        if (result) {
          let tipologia = result as TipologiaDto[];
          //this.idTipologia = tipologia.idTipologia;
          resolve(tipologia);
        }
      }, error => reject(error));
    });
  }

  fetchDistinctValues = (area: string, customtag: string, seperator: string, idTipologia: number, typeAndObject: string, inProduction: string) => {
    return new Promise((resolve, reject) => {
      let url = 'api/rest/GetDistinctCustomValues';
      console.log("----------------------typeAndObject" + typeAndObject)

      let params = { params: { IdTipologia: idTipologia, customtag: customtag, typeAndObject: typeAndObject, inProduction: inProduction } };
      this.distinctValueService.getData(url, params, false).subscribe(result => {
        if (result) {
          let items = result as CustomValue[];
          let list: string[] = [];
          items.forEach(x => {
            x.value.split(seperator).forEach(v => {
              list.push(v);
            })
          })
          resolve(list);
        }
      }, error => reject(error));
    })
  }
  setProbe = (item) => {
    this.selected.probe = item;
  }
  setClassification = (item) => {
    this.selected.classification = item;
  }
  setApplication = (item) => {
    this.selected.application = item;
  }
  setClinicalApplication = (item) => {
    this.selected.clinicalapplication = item;
    console.log(item);
    
      if (item != this.clinicalApplicationList[0]) {
        this.CaricaProbeList(item, true);
        console.log("No All");
      }
      else {
        console.log("All");
        this.CaricaProbeList("", true)
      }
  
  }
  setModel = (item) => {
    this.selected.model = item;
  }

  onResultClicked = () => {

    if (this.selected.item) {
      let customtag = "";
      if (this.selected.model && (this.selected.model !== 'All models')) {
        customtag += "Model," + this.selected.model;
      }
      if (this.selected.application && (this.selected.application !== this.applicationList[0])) {
        customtag += "Application," + this.selected.application;
      }
      if (this.selected.classification && (this.selected.classification !== this.classificationList[0])) {
        customtag += this.selected.model != 'All models' ? "#" : "";
        customtag += this.selected.application !== this.applicationList[0] ? "#" : "";
        customtag += "Classification," + this.selected.classification;
      }
      if (this.selected.probe && (this.selected.probe !== this.probeList[0])) {
        customtag += this.selected.model != 'All models' ? "#" : "";
        let clinicalapplicatinValue = "";
        if (this.selected.clinicalapplication == this.clinicalApplicationList[0]) {
          clinicalapplicatinValue = this.selected.probe
        } else {
          clinicalapplicatinValue = this.selected.clinicalapplication + "_" + this.selected.probe;
        }
        customtag += "Clinical application," + clinicalapplicatinValue;
      } else  if (this.selected.clinicalapplication && (this.selected.clinicalapplication !== this.clinicalApplicationList[0])) {
        customtag += this.selected.model != 'All models' ? "#" : "";
        customtag += "Clinical application," + this.selected.clinicalapplication;
      }
      return this.showResult(customtag, this.selected.textToSearch);

    }
  }

  /* Evolutive Maggio Giugno Luglio 2021: Dscription Link CloudBox cliccabile apre il link agli allegati CloudBox
  SubmitForm riceve [Link]**%%%%**[DescriptionLink]**%%%%**[PasswordLink]
  Ma per esigenze di rendering Link e Description link sono stati invertiti
  Modificato per le evolutive del Maggio 2023 per memorizzare su Arcadoc le letture dei link da parte degli utenti
  */

  submitForm = (values: string, iddocumento) => {
    if (values != null && values != undefined && values != "") {
      const valuesArray = values.split('**%%%%**');
      if (valuesArray[2] !== undefined) {
        this.DynamicFormElement.nativeElement.action = valuesArray[1];
        this.DynamicInputElement.nativeElement.value = valuesArray[2];
        this.DynamicFormElement.nativeElement.submit();
        if (iddocumento > 0 && valuesArray[1] != undefined) {
          let descrizioneLinkModified = valuesArray[0] != undefined ? valuesArray[0].replace("<u>", "").replace("</u>", "") : "";
          let linkToCall = valuesArray[1];
          let url = 'api/rest/setLetturaLinkInternationalActivitiesInArcadoc';
          let input = { iddocumento: iddocumento, link: linkToCall, descrizionelink: descrizioneLinkModified };
          this.documentService.postData(url, input, false).subscribe(result => {
            try {
              console.log('result setLetturaLinkInternationalActivitiesInArcadoc ', result)
            } catch (e) {
              console.log(e)
            }
          }, error => console.error('error ', error));
        }
      } else {
        console.log("Anomalia nell'Id documento: è 0");
      }
    }
  }

  /* Evolutive Maggio Giugno Luglio 2021: showResult applica la maggior parte delle evolutive richieste
  */

  showResult = (customtag: string, textTosearch: string) => {
    //alert(checkBoxValue)
    let url = 'api/rest/LoadFilteredDocuments';
    let input = { idtipologia: this.selected.item.idTipologia, customtag: customtag };

    let probeItem = new MetadatoTipologiaDto();
    let probeIndice = 0;

    this.documentService.postData(url, input, false).subscribe(result => {

      if (result) {
        let link1;
        let description1;
        let link2;
        let description2;
        let link3;
        let description3;

       // console.log('this is documents : ', result);
        this.documents = result as Documento[];

        this.documents.forEach((x, i) => {
          
          x.isCollapsed = true;
          x.metadatiDtoList.forEach(item => {

            /* Traduzione delle label richiesta dal cliente: Traduco "a mano", queste label arrivano direttamente dal db di arcadoc e lì è pericoloso modificarle */
            let itemN = item.key.replace(/_/g, " ");
            let ItemEng = "";

            let count = 0;

            switch (itemN) {
              case "Data termine validita del documento":
                ItemEng = "Document validity end date";
                break;
              case "Stato del documento":
                ItemEng = "Status of the document";
                break;
              case "Status del documento":
                ItemEng = "Status of the document";
                break;
              case "Descrizione Link 1":
                ItemEng = "Description link 1";
                break;
              case "Descrizione link 1":
                ItemEng = "Description link 1";
                break;
              case "Descrizione Link 2":
                ItemEng = "Description link 2";
                break;
              case "Descrizione link 2":
                ItemEng = "Description link 2";
                break;
              case "Descrizione Link 3":
                ItemEng = "Description link 3";
                break;
              case "Descrizione link 3":
                ItemEng = "Description link 3";
                break;
              case "GlobalServiceMarketing":
                ItemEng = "Status of the document";
                break;
              default:
                ItemEng = itemN;
            }
            item.key = ItemEng;
            
          /* Dscription Link CloudBox cliccabile apre il link agli allegati CloudBox
          Nel seguente codice mi baso sul fatto che i campi arrivano in ordine per come sono nella tipologia in arcadoc:
          1: Link
          2: Description Link
          3: Password Link
          Link e Description sono memorizzati in due variabili. Quando passa Password Link rinomino la label (Key) in Description link e butto
          come valore (value) la stringa [Link]**%%%%**[DescriptionLink]**%%%%**[PasswordLink]. Nell'html mi curo di mandare a video solo la Description con uno split
          ma devo buttare tutti e tre i valori, perchè al click della description (ciò è richiesto dal cliente) dovrò inviare in un colpo solo Link e password a submitForm.
          Questa è la soluzione trovata per farlo dinamicamente per decine di record che sono letti da un foreach.
          */

            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 1' && item.value != null && item.value != "" && item.value != undefined && item.value.trim() != "") {
              link1 = item.value
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == ('description link 1') && item.value != null && item.value != undefined && item.value.trim() != "") {
              item.value = '<u>' + item.value + '</u>'
              description1 = item.value
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && item.value != null && item.value != undefined && item.value.trim() != "" && item.value.length > 19) {
              let message = "";
              message = item.value.substring(15);
              message = message.substring(0, message.length - 14);
              message = this.Reverse(message);
              item.key = "Link 1 description (click here on the side)";
              if (description1 == undefined && link1 != undefined) {
                description1 = '<u>Link</u>'
              } else if (description1 == undefined && link1 == undefined) {
                item.key = '';
              }
              item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + message;
              link1 = undefined;
              description1 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 != undefined && description1 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 1 description (click here on the side)";
              item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
              link1 = undefined;
              description1 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 != undefined && description1 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 1 description (click here on the side)";
              description1 = '<u>Link</u>'
              item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
              link1 = undefined;
              description1 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 == undefined && description1 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 1 description (click here on the side)";
              item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
              link1 = undefined;
              description1 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 == undefined && description1 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = '';
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 2' && item.value != null && item.value != undefined && item.value.trim() != "") {
              link2 = item.value
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'description link 2' && item.value != null && item.value != undefined && item.value.trim() != "") {
              item.value = '<u>' + item.value + '</u>'
              description2 = item.value
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && item.value != null && item.value != undefined && item.value.trim() != "" && item.value.length > 19) {
              let message = "";
              message = item.value.substring(15);
              message = message.substring(0, message.length - 14);
              message = this.Reverse(message);
              item.key = "Link 2 description (click here on the side)";
              if (description2 == undefined && link2 != undefined) {
                description2 = '<u>Link</u>'
              } else if (description2 == undefined && link2 == undefined) {
                item.key = '';
              }
              item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + message;
              link2 = undefined;
              description2 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 != undefined && description2 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 2 description (click here on the side)";
              item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
              link2 = undefined;
              description2 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 != undefined && description2 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 2 description (click here on the side)";
              description2 = '<u>Link</u>'
              item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
              link2 = undefined;
              description2 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 == undefined && description2 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 2 description (click here on the side)";
              item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
              link2 = undefined;
              description2 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 == undefined && description2 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = '';
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 3' && item.value != null && item.value != "" && item.value != undefined) {
              link3 = item.value
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'description link 3' && item.value != null && item.value != "" && item.value != undefined) {
              item.value = '<u>' + item.value + '</u>'
              description3 = item.value
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && item.value != null && item.value != "" && item.value != undefined && item.value.length > 19) {
              let message = "";
              message = item.value.substring(15);
              message = message.substring(0, message.length - 14);
              message = this.Reverse(message);
              item.key = "Link 3 description (click here on the side)";
              if (description3 == undefined && link3 != undefined) {
                description3 = '<u>Link</u>'
              } else if (description3 == undefined && link3 == undefined) {
                item.key = '';
              }
              item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + message;
              link3 = undefined;
              description3 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 != undefined && description3 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 3 description (click here on the side)";
              item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
              link3 = undefined;
              description3 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 != undefined && description3 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 3 description (click here on the side)";
              description3 = '<u>Link</u>'
              item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
              link3 = undefined;
              description3 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 == undefined && description3 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = "Link 3 description (click here on the side)";
              item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
              link3 = undefined;
              description3 = undefined;
            }
            if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 == undefined && description3 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
              item.key = '';
            }
            /* Evolutive International Activities Esaote maggio/giugno 2022: Nuova linea di prodotti Preset:
            In Arcadoc abbiamo un solo campo (Clinical Application). Il dato arriva dal backend nella forma [Clinical Application]_[Correlated Probe list].
            Qui viene splittato e inserito in due caselle di filtri di ricerca. */
            if (item.key === "Clinical application") {
              probeIndice = count + 1; 
              probeItem = {
                key: "Correlated probe",
                value: item.value.split('_')[1]
              }
              item.value = item.value.split('_')[0];            
            }           
            count++;
          });
          if (probeIndice > 0 && probeItem.value !== null && probeItem.value !== undefined && probeItem.value !== "") {
            /* Inserisco il campo Correlated Probe list nell'array dei metadati, se ha un valore */
            x.metadatiDtoList.splice(probeIndice, 0, probeItem);
          }
          x.bg = 'mat-card-header-gray';//this.bgColors[this.getRandomBgIndex()];               
          x.active = 'titleTab';
          x.feedbackSingPlur = x.numeroFeedback < 2 ? "feedback" : "feedbacks"
        });
      }
    }, error => console.error('error on get documenti', error));
  }

  setFlagLetturaInArcadoc(iddocumento) {
    let url = 'api/rest/setFlagLetturaInArcadoc';
    let input = { iddocumento: iddocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      // console.log('Setflaglettura esguito: ' + result);
    }, error => console.error('error ', error));
  }


  /* Evolutive International Activities Esaote maggio/giugno 2022: Nuova linea di prodotti Preset e invio Feedback */
  memorizzaConsultazioneAllegato(iddocumento, idallegato) {
    let url = 'api/rest/memorizzaConsultazioneAllegato';
    let input = { iddocumento: iddocumento, idallegato: idallegato };
    this.documentService.postData(url, input, false).subscribe(result => {
    }, error => console.error('error ', error));
  }

  Reverse(str: string) {
    let newString = "";
    for (let i = str.length - 1; i >= 0; i--) {
      newString += str[i];
    }
    return newString;
  }

  getArcadocAttach(item: AttachmentDto, iddocumento, download: boolean) {
    let url = 'api/rest/GetAttachment';
    let params = { params: { idAllegato: item.idAllegato, idDocument: iddocumento, fileName: item.nomeFile, download: download } };
    this.fileServer.getData(url, params, false).toPromise().then(res => {
     // console.log(res);
      let attachment: AttachmentDto = res as AttachmentDto;
      let ext = attachment.nomeFile.split('.').pop();
      const downloadLink = document.createElement("a");
      const fileName = attachment.nomeFile;
      this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext)).then(blob => {
        let url = URL.createObjectURL(blob);
        if (download) {
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
        } else {
        window.open(url, '_blank')
        }
      })
    });
  }

  dataURIToBlob = (dataURI, mimeString) => {
    return new Promise(resolve => {
      let binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      let result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }
}
